module.exports = __webpack_public_path__ + "img/placeholder_prefeitos.b6271471.jpeg";